import { useState } from 'react';
import { Link } from 'react-router-dom';
// Component
import Navbar from '../Navbar';
import Login from '../Login';
import Container from '../Container';
// Images
import logoHeaderHome from '../../Images/logo/logo_OlibWhite.svg';
// Style
import './Header.css';
import MobileMenu from '../V2/MobileMenu';
import BurguerIcon from '../../Images/HomePage/burguer.png';
import Language from '../Language';
import { institutionsWithLogo } from '../../utils/getInstitutionsWithLogo';

const Header = ({ institutionCode, institutionLogo }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<header className='header'>
			<Container>
				<div className='headerContainer'>
					<div className='headerContainer__logo'>
						{(institutionsWithLogo.includes(institutionCode)) ? (
							<Link to='/'>
								<img
									className='logoInstitution'
									src={institutionLogo}
									alt='logo institution'
								/>
							</Link>
							) :
							<Link to='/'>
								<img
									className='navigationList__linkToHome'
									src={logoHeaderHome}
									alt='logo'
								/>
							</Link>
						}
					</div>

					<div className='navbarAndLoginContainer'>
						<div className='navbarAndLoginDesktop'>
							<Navbar type='white' />
						</div>

						<Language />
						<Login />
						<div className='navbarAndLoginMobile'>
							<button onClick={() => setIsOpen(!isOpen)}>
								<img src={BurguerIcon} alt='' />
							</button>
						</div>
						
					</div>

					<MobileMenu isOpen={isOpen} onClose={() => setIsOpen(false)} />
				</div>
			</Container>
		</header>
	);
};

export default Header;
